import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { validateUuid } from '@/utils/validate-uuid';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';

export interface GetListResolution886FilesParams {
	company_id: string;
	organization_id: string;
	limit?: number;
	offset?: number;
	file_name?: string;
	start_date?: Date;
	end_date?: Date;
	line_id?: string;
	sector_id?: string;
	workstation_id?: string;
}

const Service = Resolution886ReportService.getInstance();

export const useGetListResolution886Files = (params: GetListResolution886FilesParams) => {
	const isEnabled = validateUuid([params.organization_id, params.company_id]);

	return useQuery({
		queryKey: [QUERY_KEYS.GET_LIST_RESOLUTION_886_FILES, params],
		queryFn: async () => Service.getListFiles(params),
		enabled: isEnabled
	});
};
